<template>
  <div class="card p-4 shadow-sm">
    <!-- TOAST -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
      <div class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- ENCABEZADO -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Panel de Estado de Mantenimiento</h3>
    </div>

    <!-- FILTRO -->
    <div class="mb-4">
      <label class="form-label">Filtrar por Estado:</label>
      <select v-model="estadoFiltro" @change="obtenerMantenimientos" class="form-select w-auto">
        <option :value="null">-- Todos --</option>
        <option v-for="[valor, etiqueta] in Object.entries(estados)" :key="valor" :value="parseInt(valor)">
          {{ etiqueta }}
        </option>
      </select>
    </div>

    <!-- TABLA -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Habitación</th>
            <th>Descripción</th>
            <th>Estado Actual</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="mantenimientos.length === 0">
            <td colspan="4">No hay tareas de mantenimiento registradas.</td>
          </tr>
          <tr v-for="mant in mantenimientos" :key="mant.IdMantenimientoHotel">
            <td>{{ mant.habitacion_mantenimiento?.Numero }}</td>
            <td>{{ mant.DescripcionMantenimiento }}</td>
            <td>
              <span :class="estadoClase(mant.EstadoMantenimiento)">
                {{ estados[mant.EstadoMantenimiento] }}
              </span>
            </td>
            <td>
              <!-- ✅ ACCIONES -->
              <div class="d-flex flex-column align-items-center">
                <div v-if="mant.EstadoMantenimiento !== 3">
                  <select v-model="mant.EstadoMantenimiento" class="form-select form-select-sm">
                    <option v-for="[valor, etiqueta] in Object.entries(estadosFiltradosFila())"
                            :key="valor"
                            :value="parseInt(valor)">
                      {{ etiqueta }}
                    </option>
                  </select>
                  <button class="btn btn-primary btn-sm mt-2" @click="actualizarEstado(mant)">
                    Guardar Estado
                  </button>
                </div>
                <div v-else>
                  <span class="text-success fw-bold">Mantenimiento Finalizado</span>
                </div>

                <!-- ✅ BOTÓN FINALIZAR PARA ADMIN Y MANTENIMIENTO -->
                <button
                  v-if="puedeFinalizarMantenimiento && mant.EstadoMantenimiento !== 3"
                  class="btn btn-success btn-sm mt-2"
                  @click="finalizarMantenimiento(mant)"
                >
                  Finalizar Mantenimiento
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import { mapGetters } from "vuex";

export default {
  name: "MantenimientoEstado",
  data() {
    return {
      mantenimientos: [],
      estadoFiltro: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      intervalo: null, // ✅ para polling
      estados: {
        0: "Mantenimiento sin ver",
        1: "Mantenimiento visto",
        2: "En reparación",
        3: "Mantenimiento Finalizado",
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    esAdmin() {
      return this.getUser?.IdRol === 1;
    },
    puedeFinalizarMantenimiento() {
      return this.getUser?.IdRol === 1 || this.getUser?.IdRol === 4;
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    async obtenerMantenimientos() {
      try {
        const res = await axios.get(`${API_URL}/mantenimiento-hotel`);
        let lista = res.data;
        lista.sort((a, b) => b.IdMantenimientoHotel - a.IdMantenimientoHotel);
        if (this.estadoFiltro !== null) {
          lista = lista.filter((m) => m.EstadoMantenimiento === this.estadoFiltro);
        }
        this.mantenimientos = lista;
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cargar tareas.", "danger");
      }
    },
    async actualizarEstado(mant) {
      try {
        await axios.put(`${API_URL}/mantenimiento-hotel/${mant.IdMantenimientoHotel}`, {
          EstadoMantenimiento: mant.EstadoMantenimiento,
        });
        this.mostrarAlerta("Estado actualizado correctamente");
        this.obtenerMantenimientos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar.", "danger");
      }
    },
    async finalizarMantenimiento(mant) {
      try {
        await axios.put(`${API_URL}/mantenimiento-hotel/${mant.IdMantenimientoHotel}`, {
          EstadoMantenimiento: 3,
        });
        this.mostrarAlerta("Mantenimiento finalizado");
        this.obtenerMantenimientos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al finalizar.", "danger");
      }
    },
    estadoClase(estado) {
      switch (estado) {
        case 0: return "badge bg-secondary";
        case 1: return "badge bg-warning text-dark";
        case 2: return "badge bg-danger";
        case 3: return "badge bg-success";
        default: return "";
      }
    },
    estadosFiltradosFila() {
      return {
        1: this.estados[1],
        2: this.estados[2],
        3: this.estados[3],
      };
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
  },
  mounted() {
    this.obtenerMantenimientos();
    this.intervalo = setInterval(this.obtenerMantenimientos, 30000); // ✅ cada 30 segundos
  },
  beforeUnmount() {
    clearInterval(this.intervalo); // ✅ evita fugas de memoria
  },
};
</script>


<style scoped>
.badge {
  font-size: 0.9rem;
  padding: 0.5em 0.75em;
}
</style>
